<template>
    <div class="Profile-settings">
        <div class="Profile-info">
            <div class="Profile_img_name">
                <img class="img-responsive img-circle changedProfilePic" :src="profilePic">
                <label>
                    <h3>
                        <a href="javascript:;" class="userName">
                            <!-- {{loggedInUserObj.name}} -->
                            <!-- BUG 160446 -->
                            {{name}}
                        </a>
                    </h3>
                    <!-- <span title="Desgination">{{loggedInUserObj.designation}}</span> -->
                    <!-- BUG 160446 -->
                    <span title="Email">{{email}}</span><br>
                    <span title="Desgination">{{designation}}</span>
                    <!-- <span title="Role">{{loggedInUserObj.Role == "HRManager" ? "HR Manager" : loggedInUserObj.Role }}</span> -->
                </label>
            </div>
            <div class="Profile-edit">
                <a @click="ShowProfilePage()"><i class="fa fa-pencil" aria-hidden="true"></i></a>
            </div>
        </div>
        <div class="Change-password">
        <a id="pwdGuidelinse" v-tooltip.left="{ html : 'stepsToFollow' }" style="float:right;text-decoration:underline;padding: 13px 52px 0px 0px;font-weight:600;">Password Guidelines</a>
            <div style="text-align:justify;" id="stepsToFollow" v-html="'<br/><h3><b style=\'color:#da5353;\'>Password Guidelines</b></h3><b style=\'color:#848282;\'>Password should contain at least 8 characters and must contain following requirements:</b><br/><p>One Upper Case</p><p>One Lower Case</p><p>One Number</p><p>One Special Character</p><br/><b style=\'color:#848282;\'>Passwords MUST NOT contain:</b><br/><p>3 sequential characters</p><p>More than 3 identical sequential characters in a row</p><p>Any of the last six passwords</p><br/><b style=\'color:#848282;\'>Password MUST NOT contain your personal information:</b><br/><p>First Name<p/><p>Last Name</p><p>Date of Birth</p><p>User Name</p><p>Phone Number</p><br/>'"> </div>
             <h3>Change Password</h3>
            <div style="width:100%;">
                <div class="cp-block">
                    <label>Current Password<span class="star-red">*</span></label>
                    <input type="password" :maxLength="256" v-model.trim="currentPwd" autocomplete="false" placeholder="Current Password" :class="{ 'ob-vuelidate_input-error': $v.currentPwd.$error }" @keyup="checkPass" />
                    <span class="ob-vuelidate_error-msg" v-if="$v.currentPwd.$dirty && !$v.currentPwd.required">Please enter your Current Password</span>
                    <span class="ob-vuelidate_error-msg" v-if="$v.currentPwd.$dirty && !$v.currentPwd.minLength">Your password should contain 6 characters</span>
                    <span class="ob-vuelidate_error-msg" v-if="$v.currentPwd.$dirty && $v.currentPwd.required && $v.currentPwd.minLength"><span v-if="this.showError">{{error_msg}}</span></span>
                </div>
            </div>
            <div class="cp-block">
                <label>New Password<span class="star-red">*</span></label>
                <input type="password" :maxLength="256" v-model.trim="newPwd" autocomplete="false" placeholder="New Password" :class="{ 'ob-vuelidate_input-error': $v.newPwd.$error }" @keyup="checkPasswordStrength(newPwd)"/>
                <span class="ob-vuelidate_error-msg" v-if="$v.newPwd.$dirty && !$v.newPwd.required">Please enter your New Password</span>
                <span class="ob-vuelidate_error-msg" v-if="$v.newPwd.$dirty && !$v.newPwd.minLength">Your password should contain 8 characters</span>
            </div>
            <div class="cp-block">
                <label>Confirm Password<span class="star-red">*</span></label>
                <input type="password" v-model.trim="confirmPwd" autocomplete="false" placeholder="Confirm Password" :class="{ 'ob-vuelidate_input-error': $v.confirmPwd.$error }" />
                <span class="ob-vuelidate_error-msg" v-if="$v.confirmPwd.$dirty && !$v.confirmPwd.requiredIf">Please re-enter your New Password</span>
                <!--<span class="ob-vuelidate_error-msg" v-if="$v.confirmPwd.$dirty && !$v.confirmPwd.minLength">Your password must contain more than 6 characters</span>-->
                <span class="ob-vuelidate_error-msg" v-if="$v.confirmPwd.$dirty && !$v.confirmPwd.sameAsPassword">New Password and Confirm Password doesn’t match. Please re-enter passwords</span>
            </div>
            <div id="showError" style="display: none;">
              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/danger_red_fill_icon.svg`"/>
              <span class="pwdErrorMsg" style="padding: 0px 0px 10px 0px;color: #d60000;font-size:12px;"></span>
            </div>
            <div>
                <ob-button type="primary" @click="changePwd()">Save</ob-button>
            </div>
        </div>
        <profile-pic-modal :openModal.sync="openprofilemodal"></profile-pic-modal>
    </div>

</template>
<script>
import {
  required,
  sameAs,
  minLength,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import ProfilePicModal from "./ProfilePicModal.vue"
import c from "Vue/Core/constants.js";
export default {
  data() {
    return {
      currentPwd: "",
      newPwd: "",
      confirmPwd: "",
      openprofilemodal:false,
      empData:'',
      error_msg:'',
      showError:false
    };
  },
  validations: {
    currentPwd: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(256)
    },
    newPwd: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(256)
    },

    confirmPwd: {
      requiredIf: requiredIf(() => {
        return this.confirmPwd == "";
      }),
      sameAsPassword: sameAs("newPwd")
    }
  },
  mounted() {
    this.$v.currentPwd.$reset();
    this.$v.newPwd.$reset();
    this.$v.confirmPwd.$reset();
  },
  created(){
   this.getProfile()
    events.listen('profileUpdate',()=>{
        this.getProfile()
    })
    events.listen('profileRemoved',()=>{
        this.getProfile()
    })

  },
  computed: {
    // BUG 160446 start
    name() {
      return this.empData.Name || "";
    },
    designation() {
      return this.empData.Designation || "";
    },
    email() {
      return this.empData.Email || "";
    },
    // BUG 160446 end
    profilePic() {
     if (
       this.empData.ProfilePicLink != "" &&
       this.empData.ProfilePicLink != null
      )
        return this.empData.ProfilePicLink;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
  },
  components: {
    "profile-pic-modal": ProfilePicModal,
  },
  methods: {
    checkPass(){
            if(this.currentPwd.length >= 6 && this.error_msg != '' && this.showError == true){
                this.showError = false
                this.error_msg = ''
            }
            // else if(this.showError == true && this.error_msg != ''){
            //     this.showError = false
            //     this.error_msg = ''
            // }
            else{
                this.showError = true
            }
        },
    getProfile(){
      this.$loading({ loadingText: "Loading..." });
      ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
                    if(res.data.State == true){
                            this.$loading({}).close();
                            this.empData = res.data.Employee
                    }
                    else{
                      this.$loading({}).close();
                      this.ESSEnableDisable(res)
                    }
             })
      },
     ShowProfilePage() {
      this.openprofilemodal=true
    },
    changePwd() {
      this.$v.currentPwd.$touch();
      this.$v.newPwd.$touch();
      this.$v.confirmPwd.$touch();
      if (
        this.$v.currentPwd.$invalid == false &&
        this.$v.newPwd.$invalid == false &&
        this.$v.confirmPwd.$invalid == false
      ) {
        let encodedCurrentPwd = btoa(this.currentPwd)
        let encodedNewPwd = btoa(this.newPwd)
        let encodedConfirmPwd = btoa(this.confirmPwd)
        let pwdObj = {
          OldPassword: encodedCurrentPwd,
          NewPassword: encodedNewPwd,
          ConfirmPassword: encodedConfirmPwd
        };
        var pwdErrorMsg = this.checkPasswordStrength(this.newPwd)
        if(pwdErrorMsg != '')
        {
          $("#showError").show()
          $(".pwdErrorMsg").text(pwdErrorMsg);
        }
        else{
          this.$loading({ loadingText: "Updating changed password..." });
          ajax.post("ChangePassword", pwdObj, res => {
            this.$loading({}).close();
            if (res.data.State == true) {
              this.clearValues();
              this.$v.currentPwd.$reset();
              this.$v.newPwd.$reset();
              this.$v.confirmPwd.$reset();
              // this.$router.push({path: '/admin-settings'})
                  this.$message({
                    type: "success",
                    message: "Password changed successfully."
                  });
            } else {
                this.ESSEnableDisable(res)
                if(res.data.Message == 'Please enter correct password')
                    this.error_msg = res.data.Message
                else{
                    $("#showError").show()
                    $(".pwdErrorMsg").text(res.data.Message);
                }
                // this.$message({
                //   type: "error",
                //   message: res.data.Message
                // });
            }
          });
        }
      }
    },

    checkPasswordStrength(pwd){
        var pwdErrorMsg = "";
        $("#showError").hide()
        if(pwd.length >= 8){
          if(this.newPwd == this.currentPwd)
            pwdErrorMsg = "Current Password and New Password should not be same"
          else{
            var ruleCountSatisfied = 0;
            if(pwd.search(/[A-Z]/) < 0)
              ruleCountSatisfied++
            if(pwd.search(/[a-z]/) < 0)
              ruleCountSatisfied++
            if(pwd.search(/[0-9]/) < 0)
              ruleCountSatisfied++
            if(pwd.search(/[! “ # $ % & '( ) * + , -./ : ; < = > ?@ [ \] ^ _ `{ | } ~]/) < 0)
              ruleCountSatisfied++
            if(ruleCountSatisfied > 0)
              pwdErrorMsg = "The password you have entered doesn't meet the Password Guidelines"
            // else{
            //   var seqCheck = this.sequentialCheckPwd(pwd);
            //     if(!seqCheck)
            //         pwdErrorMsg = "The password you have entered doesn't meet the Password Guidelines"
            // }
          }
        }
        if(pwdErrorMsg != '')
            $("#showError").show()
      $(".pwdErrorMsg").text(pwdErrorMsg);
      return pwdErrorMsg;
    },

    sequentialCheckPwd(s) {
        // Check for sequential numerical characters
        for (var i in s)
                if (((+s[+i + 1] == +s[i] + 1 && +s[+i + 2] == +s[i] + 2) ||
                    (+s[+i + 1] == +s[i] - 1 && +s[+i + 2] == +s[i] - 2)) ||
                    ((i < s.length - 2) && (s[i] == s[i + 1] && s[i] == s[i + 2])))
                    return false;
            // Check for sequential alphabetical characters String.fromCharCode(s.charCodeAt(i) + 2) == s[+i + 2]
            for (var i in s)
                if (((String.fromCharCode(s.charCodeAt(i) + 1) == s[+i + 1] && String.fromCharCode(s.charCodeAt(i) + 2) == s[+i + 2])
                    || (String.fromCharCode(s.charCodeAt(i) + 1) == s[+i - 1] && String.fromCharCode(s.charCodeAt(i) + 2) == s[+i - 2]))
                    || ((i < s.length - 2) && (String.fromCharCode(s.charCodeAt(i)) == s[+i + 1] && String.fromCharCode(s.charCodeAt(i)) == s[+i + 2])))
                    return false;
        return true;
    },
    clearValues() {
      (this.currentPwd = ""), (this.newPwd = ""), (this.confirmPwd = "");
    }
  }
};
</script>
<style lang="scss" scoped>
.Profile-settings {
  height: 100%;
  .Profile-info {
    display: inline-block;
    padding: 20px;
    width: 100%;
    border-bottom: 1.2px dashed #ddd;
  }
  .Profile_img_name {
    display: inline-block;
    float: left;
    vertical-align: middle;
    img {
      display: inline-block;
      width: 47px;
      height: 47px;
      vertical-align: top;
    }
    label {
      max-width: 100%;
      /*width: 180px;*/
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin: 4px;
      font-weight: 400;
      font-size: 13px;

    }
    h3 {
      margin-top: 3px;
      color: #143361;
      font-weight: 600;
      font-size: 13px;
      line-height: 25px;
      padding: 0;
      margin: 0;
    }
    span {
      font-size: 13px;
      font-weight: 600;
      color: #143761;
    }
  }
  .Profile-edit {
    display: inline-block;
    float: right;
    padding: 20px;
    i {
      font-size: 18px;
      color: #8e8e8c;
    }
  }
}
.Change-password {
  font-size: 13px;
  height: calc(100% - 115px);
  overflow: auto;
  h3 {
    color: #143361;
    font-weight: 600;
    margin: 0;
    padding: 20px 0;
  }
  .cp-block {
    display: inline-block;
    width: 25%;
    padding: 0 50px 50px 0;
    position: relative;
    label{
      font-weight: 400;
    }
    input {
      display: block;
      width: 100%;
      height: 31px;
      padding: 6px 12px;
      font-size: 12px;
      line-height: 1.42857;
      color: #555555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }
  .ob-vuelidate_error-msg {
    position: absolute;
  }
  input.ob-vuelidate_input-error {
    border: 1px solid #d60000 !important;
  }
  .star-red {
    color: #d60000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSSettings/EmpProfileSettings.vue